import { useEditor, useQuickReactor } from "@tldraw/editor";
import { useActions } from "tldraw";
import { useEffect, useRef } from "react";
import { useNotepadStore } from "@/features/notepad/store/useNotepadStore";

/** Tracks whether all canvas shapes are out of view and syncs to NotepadStore.
 *  Also registers the "back to content" action so it can be triggered from outside tldraw. */
export function CanvasOutOfViewTracker() {
  const editor = useEditor();
  const actions = useActions();
  const setContentOutOfView = useNotepadStore((s) => s.setContentOutOfView);
  const registerBackToContent = useNotepadStore((s) => s.registerBackToContent);
  const unregisterBackToContent = useNotepadStore((s) => s.unregisterBackToContent);
  const rShowing = useRef(false);
  const setContentOutOfViewRef = useRef(setContentOutOfView);
  setContentOutOfViewRef.current = setContentOutOfView;

  useQuickReactor(
    "out-of-view tracker",
    () => {
      const shapeIds = editor.getCurrentPageShapeIds();
      const nowVisible =
        shapeIds.size > 0 && shapeIds.size === editor.getNotVisibleShapes().size;
      if (rShowing.current !== nowVisible) {
        rShowing.current = nowVisible;
        setContentOutOfViewRef.current(nowVisible);
      }
    },
    [editor],
  );

  useEffect(() => {
    registerBackToContent(() => {
      actions["back-to-content"].onSelect("helper-buttons");
    });
    return () => unregisterBackToContent();
  }, [actions, registerBackToContent, unregisterBackToContent]);

  return null;
}
